/**
 * MmtCard — v1.1 refactor.
 * Lifted out of ObjectiveAssessment.jsx. Manual Muscle Testing (MMT) table
 * with side / grade / region / notes per muscle group, AI-scribe support and
 * region filtering. Pure presentational — receives row handlers + sub-
 * components as props so the parent owns state and the row helpers.
 */
import React from 'react';
import { Dumbbell, Trash2 } from 'lucide-react';
import SmartSelect from './SmartSelect';
import { MMT_MUSCLES } from '../lib/pe-options';

const MMT_GRADES = ['0','1','2-','2','2+','3-','3','3+','4-','4','4+','5'];
const SIDES = ['L','R','Both','N/A'];
const REGION_OPTS = ['upper','lower','trunk'];

export default function MmtCard({
  rows = [], regionFilter = 'all', patient_id,
  updRow, addRow, delRow, appendScribeRow,
  Section, GridTable, AddBtn,
}) {
  return (
    <Section title="Manual muscle testing (MMT) — Left / Right" icon={Dumbbell} testid="sec-mmt"
             scribeKey="mmt" patientId={patient_id}
             onScribeText={appendScribeRow('mmt', (text) => ({
               muscle: 'AI · ' + text.slice(0, 60), grade_left: '', grade_right: '',
               notes: text, reference: '',
             }))}>
      <GridTable cols={['Muscle group','Side','Grade','Region','Notes']}>
        {(rows || []).map((r, i) => (regionFilter === 'all' || r.region === regionFilter) && (
          <tr key={i} data-testid={`mmt-${i}`}>
            <td>
              <SmartSelect value={r.muscle || ''}
                           onChange={(v) => updRow('muscle_tests', i, { muscle: v })}
                           options={MMT_MUSCLES}
                           placeholder="Pick muscle or Other…"
                           testid={`mmt-${i}-muscle`}
                           compact/>
            </td>
            <td>
              <select className="input" value={r.side || ''}
                      onChange={e => updRow('muscle_tests', i, { side: e.target.value })}>
                {['', ...SIDES].map(s => <option key={s}>{s}</option>)}
              </select>
            </td>
            <td>
              <select className="input" value={r.grade || ''}
                      onChange={e => updRow('muscle_tests', i, { grade: e.target.value })}>
                {['', ...MMT_GRADES].map(g => <option key={g}>{g}</option>)}
              </select>
            </td>
            <td>
              <select className="input" value={r.region || ''}
                      onChange={e => updRow('muscle_tests', i, { region: e.target.value })}>
                {['', ...REGION_OPTS].map(g => <option key={g}>{g || '—'}</option>)}
              </select>
            </td>
            <td>
              <input className="input" value={r.notes || ''}
                     onChange={e => updRow('muscle_tests', i, { notes: e.target.value })}/>
            </td>
            <td className="print:hidden">
              <button onClick={() => delRow('muscle_tests', i)} className="text-[#B83A3A] p-1">
                <Trash2 className="w-4 h-4"/>
              </button>
            </td>
          </tr>
        ))}
      </GridTable>
      <AddBtn onClick={() => addRow('muscle_tests', {
        muscle: '', side: '', grade: '',
        region: regionFilter === 'all' ? '' : regionFilter, notes: '',
      })} testid="add-mmt"/>
    </Section>
  );
}
